import { useEffect, useMemo, useState } from "react";
import { Menu, X } from "lucide-react";
import { buildNavbarContext, buildNavItems } from "../../../Utils/buildContext";

import HamburgerDropdownItem from "./HamburgerDropdownItem";

export default function HamburgerMenu({ lang, navItems: navItemsProp }) {
  const [open, setOpen] = useState(false);

  const navbarContext = buildNavbarContext(lang);

  // NavBar zaten navItems yolluyor; ama yollamazsa burada üretelim
  const navItems = useMemo(
    () => navItemsProp ?? buildNavItems(navbarContext),
    [navItemsProp, navbarContext]
  );

  // ESC ile kapansın
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, []);

  // açıkken scroll kilitle
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => (document.body.style.overflow = "");
  }, [open]);

  const closeMenu = () => {
    setOpen(false);
  };

  return (
    <>
      <button
        type="button"
        className={`hm-btn ${open ? "is-open" : ""}`}
        aria-label={open ? "Close menu" : "Open menu"}
        aria-expanded={open}
        aria-controls="hm-panel"
        onClick={() => setOpen((v) => !v)}
      >
        <span className="hm-btn__text">Menu</span>
        <span className="hm-btn__icon" aria-hidden="true">
          {open ? <X /> : <Menu />}
        </span>
      </button>

      <div
        className={`hm-overlay ${open ? "is-open" : ""}`}
        onClick={() => setOpen(false)}
      />

      <aside
        id="hm-panel"
        className={`hm-panel ${open ? "is-open" : ""}`}
        aria-hidden={!open}
      >
        <div className="hm-panel__header">
          <div className="hm-panel__title">Menu</div>
          <button
            type="button"
            className="hm-panel__close"
            onClick={() => setOpen(false)}
            aria-label="Close"
          >
            <X />
          </button>
        </div>

        <nav className="hm-panel__nav">
          {navItems.map((item) =>
            item.type === "dropdown" ? (
              <HamburgerDropdownItem
                className='hm-menu-option'
                key={item.id}
                item={item}
                onNavigate={closeMenu}
              />
            ) : (
              <a key={item.href} href={item.href} onClick={closeMenu} className='hm-menu-option'>
                {item.label}
              </a>
            )
          )}
        </nav>
      </aside>
    </>
  );
}